export enum ClientDataType {
  Vendor = 'vendor',
  Supplier = 'supplier',
  Reference = 'reference',
}
